import { gql } from "../../../__generated__";

export const UPDATE_FESTIVAL_SETTINGS =
  gql(`mutation updateFestivalSettingsMutation($editionId : String!, $hiddenMenuItems: String! $countdownDate: DateTime) {
    updateFestivalSettings(editionId: $editionId, hiddenMenuItems: $hiddenMenuItems, countdownDate: $countdownDate) {
      id
    }
  }`);

export const ADMIN_UPDATE_FESTIVAL_SETTINGS =
  gql(`mutation updateFestivalSettingsAdmin($minVersion:String!, $downForMaintenance: Boolean!, $editionId : String!) {
    updateFestivalSettingsAdmin(minVersion: $minVersion, downForMaintenance: $downForMaintenance, editionId: $editionId) {
      id
    }
  }`);

export const GET_FESTIVAL_SETTINGS = gql(`
query settings {
    settings {
      id
      minVersion
      downForMaintenance    
      editionId
      hiddenMenuItems
      countdownDate
    }
    versionNumber
  }`);
